import { createClient } from '@supabase/supabase-js';

// Access environment variables using Vite's import.meta.env
// We keep the hardcoded values as a fallback for the instant preview environment
// Using (import.meta as any) to avoid TypeScript errors if vite/client types are missing
const supabaseUrl = (import.meta as any).env?.VITE_SUPABASE_URL || 'https://onkhwldwcbhvmnjgxegc.supabase.co';
const supabaseKey = (import.meta as any).env?.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9ua2h3bGR3Y2Jodm1uamd4ZWdjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU2MTkwODYsImV4cCI6MjA4MTE5NTA4Nn0._EsBNn1wSrumShKaZMw4iEGE9mlJKfjfCbJ0licB3Nw';

export const supabase = createClient(supabaseUrl, supabaseKey, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true
    }
});